import routes from '@config/routes';
import withAuthGuard from '@hocs/withAuthGuard';
import SignInPage from '@pages/SignInPage/SignInPage';

export default withAuthGuard({
  condition: { isAuth: false },
  redirectTo: routes.HOME,
})(SignInPage);
